import { displayScreen } from 'redux/actions/screen_status';
import FetchingQuestionsScreen from 'components/screens/fetchingquestions/fetchingquestions_container'

export const showFentchingScreen = (contentId) => displayScreen({
    name: 'fetchingQuestions',
    type: 'full',
    visible: true,
    content: <FetchingQuestionsScreen contentId={contentId} />
});

export const removeFetchingScreen = () => displayScreen({
    name: 'fetchingQuestions',
    type: 'full',
    visible: false,
    content: null
});
